export default __webpack_public_path__ + "static/media/xmas-slide3.2d408da4.jpg";